export default __webpack_public_path__ + "static/media/kla-2.2f3f81b8.jpg";